const months = [
  '',
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const getPrettyMonth = (dateNum) => {
  let dateString = dateNum.toString();
  return months[parseInt(dateString.slice(4))] + ' ' + dateString.slice(0, 4);
};
